import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import Popover from '@mui/material/Popover';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useEffect, useRef, useState } from 'react';
import Carousel from 'react-multi-carousel';
import DialogDrawSlide from './DialogDrawSlide';

const DialogDraw = (props: any) => {
  const [carouselIndex, setCarouselIndex] = useState(props.rowSelected || 0);
  const carouselRef = useRef<any>();

  useEffect(() => {
    setTimeout(() => {
      if (carouselRef && carouselRef.current) {
        carouselRef.current.goToSlide(props.rowSelected);
      }
    }, 1100);
  }, [carouselRef, props.rowSelected]);

  useEffect(() => {
    // console.log(carouselIndex);
  }, [carouselIndex]);

  const handleGoToSlide = (index: number) => {
    if (carouselRef && carouselRef.current) {
      carouselRef.current.goToSlide(index);
    }
  };

  const CustomDot = ({ index, onClick, active }: any) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [thumbnailLarge, setThumbnailLarge] = useState<any>(null);

    const handleOnClick = (image: any, event: any) => {
      setThumbnailLarge(image);
      setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
      setAnchorEl(null);
    };

    const handleCloseItemThumbnail = () => {
      console.log('kkjk k kj kjk ');
      setAnchorEl(null);
    };

    return (
      <Box margin={'4px'}>
        <button
          style={{
            backgroundColor: 'transparent',
            border: active ? '2px solid #23B7E5' : '1px solid #F3F3F3',
          }}
        >
          {props.schemaList &&
            props.schemaList[index].records[0]?.items.map(
              (image: any, idx: number) => {
                return (
                  // <SlideItem key={index} image={image} />
                  <Box key={idx}>
                    <img
                      onClick={(event) => handleOnClick(image, event)}
                      // onDoubleClick={(e) => {
                      //   onClick();
                      //   setCarouselIndex(idx);
                      //   e.preventDefault();
                      // }}
                      src={image.thumbnail}
                      alt={image.id}
                      style={{
                        height: '75px',
                        margin: 'auto',
                        width: '100px',
                        objectFit: 'contain',
                        cursor: 'pointer'
                      }}
                    />
                  </Box>
                );
              }
            )}
        </button>
        <Popover
          id={'popover-thumbnail-item'}
          open={open}
          anchorEl={anchorEl}
          onClose={handlePopoverClose}
          sx={{
            '& .MuiPaper-root.MuiPopover-paper': {
              boxShadow: '0px 6px 12px 0px #0000001A;',
              // height: '270px',
              overflow: 'unset',
            },
          }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
        >
          <Stack>
            <Stack direction={'row'} justifyContent={'space-between'} p={'4px'}>
              <Typography>
                {thumbnailLarge ? thumbnailLarge.origin[0].name : ''}
              </Typography>

              <Box
                component={'img'}
                src='/images/icons/ic-close.svg'
                alt='icon close'
                onClick={handleCloseItemThumbnail}
                width={'24px'}
                height={'24px'}
                sx={{
                  cursor: 'pointer',
                }}
              ></Box>
            </Stack>
            <Box
              component='img'
              src={thumbnailLarge ? thumbnailLarge.thumbnail : ''}
              alt='face-patient'
              width={'270px'}
              height={'270px'}
              sx={{ objectFit: 'contain', p: '4px' }}
            />
            <Box
              component={'img'}
              src='/images/icons/ic-arrow-right.svg'
              alt='icon close'
              onClick={() => handleGoToSlide(index)}
              width={'32px'}
              height={'32px'}
              sx={{
                cursor: 'pointer',
                position: 'absolute',
                zIndex: 1300,
                right: '-38px',
                top: 0,
                backgroundColor: '#F5F7FA',
                borderRadius: '8px',
                p: '4px'
              }}
            ></Box>
          </Stack>
        </Popover>
      </Box>
    );
  };

  return (
    <>
      <Dialog
        open={props.openDialogDraw}
        onClose={props.handleCloseDialogDraw}
        scroll={'paper'}
        aria-labelledby='scroll-dialog-title'
        aria-describedby='scroll-dialog-description'
        sx={{
          '& .MuiPaper-root.MuiPaper-elevation.MuiDialog-paper': {
            width: '1396px',
            maxWidth: '1396px',
            height: '90vh',
          },
        }}
        id='dialog-draw'
      >
        {props.isKarteEdit ? (
          <Box
            width={'100%'}
            height={'100%'}
            p={'16px'}
            sx={{
              '& .react-multi-carousel-dot-list ': {
                position: 'relative',
                overflow: 'auto',
                justifyContent:
                  props.schemaList.length > 5 ? 'flex-start' : 'center',
              },
              // '& .react-multi-carousel-item': {
              //   display: 'flex',
              //   justifyContent: 'center',
              //   alignItems: 'center',
              // },
            }}
          >
            <Carousel
              ref={carouselRef}
              additionalTransfrom={0}
              arrows
              autoPlaySpeed={3000}
              centerMode={false}
              className=''
              containerClass='container'
              customDot={<CustomDot />}
              dotListClass=''
              draggable={false}
              swipeable={false}
              focusOnSelect={false}
              // infinite
              itemClass=''
              keyBoardControl
              minimumTouchDrag={80}
              pauseOnHover
              renderArrowsWhenDisabled={false}
              renderButtonGroupOutside={false}
              renderDotsOutside={true}
              responsive={{
                desktop: {
                  breakpoint: {
                    max: 3000,
                    min: 1024,
                  },
                  items: 1,
                },
                mobile: {
                  breakpoint: {
                    max: 464,
                    min: 0,
                  },
                  items: 1,
                },
                tablet: {
                  breakpoint: {
                    max: 1024,
                    min: 464,
                  },
                  items: 1,
                },
              }}
              rewind={false}
              rewindWithAnimation={false}
              rtl={false}
              shouldResetAutoplay
              showDots
              sliderClass=''
              slidesToSlide={1}
              afterChange={(previousSlide, { currentSlide }) => {
                setCarouselIndex(currentSlide);
              }}
            >
              {props.schemaList.map((schema: any, index: number) => {
                return (
                  <DialogDrawSlide
                    key={index}
                    idxSlide={index}
                    openDialogDraw={props.openDialogDraw}
                    handleCreateDraw={props.handleCreateDraw}
                    handleCloseDialogDraw={props.handleCloseDialogDraw}
                    handleBtnReturn={props.handleBtnReturn}
                    handleReloadData={props.handleReloadData}
                    templateActive={props.templateActive}
                    templateDetail={props.templateDetail}
                    karteEdit={schema}
                    isKarteEdit={props.isKarteEdit}
                    patient={props.patient}
                    schemaList={props.schemaList}
                  />
                );
              })}
            </Carousel>
          </Box>
        ) : (
          <DialogDrawSlide
            openDialogDraw={props.openDialogDraw}
            handleCreateDraw={props.handleCreateDraw}
            handleCloseDialogDraw={props.handleCloseDialogDraw}
            handleBtnReturn={props.handleBtnReturn}
            handleReloadData={props.handleReloadData}
            templateActive={props.templateActive}
            templateDetail={props.templateDetail}
            karteEdit={null}
            isKarteEdit={props.isKarteEdit}
            patient={props.patient}
            schemaList={props.schemaList}
          />
        )}
      </Dialog>
    </>
  );
};

export default DialogDraw;
